import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import { type PolymorphicElementProps, type TagName } from '../types'

import styles from './grid.module.css'

export type GridProps = ComponentPropsWithoutRef<TagName> &
  PolymorphicElementProps & {
    isReversed?: boolean
  }

export function Grid(props: GridProps): ReactElement {
  const { as = 'div', children, className, isReversed = false, ...rest } = props

  const Component = as

  return (
    <Component className={clsx(styles.grid, isReversed && styles.isReversed, className)} {...rest}>
      {children}
    </Component>
  )
}
